import { gql } from '@apollo/client'

export const FileFragment = gql`
  fragment File on File {
    fileType
    fileName
    fileDescription
    url
    name
    uploaded
  }
`
